import { AxiosResponse } from "axios"

export function toData<T>(response: AxiosResponse<T>) {
  return response.data
}

/**
 * Good for testing
 */
export async function sleep(milliseconds: number) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}
